<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="partner_wrap container">
      <div v-for="(item, index) in list" :key="index">
        <titleConfig
          v-if="item.type == '1' && item.contacts.length > 0"
          :title="langSet == 'cn' ? '展位销售' : 'Booth Sales Reps'"
          :type="2"
        ></titleConfig>
        <titleConfig
          v-if="item.type == '2' && item.contacts.length > 0"
          :title="langSet == 'cn' ? '市场合作' : 'Market Cooperation'"
          :type="2"
        ></titleConfig>
        <titleConfig
          v-if="item.type == '3' && item.contacts.length > 0"
          title="国际销售&市场"
          :type="2"
        ></titleConfig>
        <div class="partner_list" v-if="item.contacts.length > 0">
          <contacts class="partner_item" :list="item.contacts"></contacts>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import contacts from "@/components/contacts.vue";
import { contactsList } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
    contacts,
  },
  data() {
    return {
      langSet: "",
      list: [],
      metaData: {},
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    this.getContactsList(1);
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getContactsList(type) {
      let data = {
        types: type,
        page_type: 0,
      };
      const res = await contactsList(data);
      let { lists } = res.data;
      this.list = this.groupLists(lists);
    },
    groupLists(array) {
      return array.reduce((acc, item) => {
        const typeKey = item.type || "undefined";
        if (!acc[typeKey]) {
          acc[typeKey] = {
            type: typeKey,
            contacts: [],
          };
        }
        acc[typeKey].contacts.push(item);
        return acc;
      }, {});
    },
  },
};
</script>
<style lang="scss" scoped>
.partner_wrap {
  padding: 80px 0;
  min-height: 500px;
}
.partner_list {
  margin-bottom: 60px;
  .partner_item {
    width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  .partner_wrap{
    padding: 0.58rem 0;
  }
  .partner_list {
    margin-bottom: 1.15rem;
  }
}
</style>